/**
 *
 * Filters material family data on the model edit page.
 *
 */

var $ = require('./../sw-jquery');
var GroupFilter = require('./../../lib/views/GroupFilter.js');
var SELECTED_CLASS_ATTR = 'data-sw-group-filter-selected-class';
var SELECTED_CLASS = 'sw-group-filter__button--selected';

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-group-filter ]').each(function() {
    var $el = $(this);
    var groupIdAttrName = 'data-sw-filter-group-id';
    var $selectedClassAttribute = $el.attr(SELECTED_CLASS_ATTR);
    var selectedAttr = $selectedClassAttribute ? $selectedClassAttribute : SELECTED_CLASS;

    new GroupFilter({
      el: $el,
      groupIdAttrName: groupIdAttrName,
      selectedClass: selectedAttr
    });
  });

};
